import {
  Form,
  Toast,
  Dialog,
  Input,
  Uploader,
  Picker,
  FormInstance,
  Button,
  Cascader,
} from 'react-vant';
import styles from './index.less';
import { positionTypeList, ugentTypeList } from './config';
import { useModel, useLocation } from '@umijs/max';
import { useEffect, useRef, useState } from 'react';
import { getEventConfigTree, queryCommonUpload } from '@/service/rentHouse';
import { addTicketRecord, updateTicketRecord } from '@/service/repaire';

const RepairContent = () => {
  const [eventList, setEventList] = useState([]);
  const nameslist = useRef([{
    text: ''
  }])
  const { ownerInformation, defaultRoom } = useModel(
    'useDefaultRoom',
    (model) => ({
      ownerInformation: model.ownerInformation,
      defaultRoom: model.defaultRoom,
    }),
  );

  const [form] = Form.useForm();
  const formRef = useRef<FormInstance>(null);
  const location = useLocation();
  const data = new URLSearchParams(location.search).get('sequenceNbr');

  useEffect(() => {
    console.log(defaultRoom, ownerInformation)
    if (ownerInformation) {
      form.setFieldsValue({
        reporter: ownerInformation?.nickName,
        reporterPhone: ownerInformation?.phonenumber,
      });

      getEventConfigTree({}).then((res: any) => {
        if (res && res.code === 200) {
          setEventList(
            (res.data || []).map((item: any) => {
              return {
                ...item,
                text: item.categoryName,
                value: item.sequenceNbr,
                children:
                  (item.children &&
                    item.children.length &&
                    item.children.map((subItem: any) => {
                      return {
                        ...subItem,
                        text: subItem.categoryName,
                        value: subItem.sequenceNbr,
                      };
                    })) ||
                  [],
              };
            }),
          );
        }
      });
    }
  }, [ownerInformation]);

  const changePicker = (v: any, selectedOptions: any) => {
    console.log('9999', v);
    console.log('8888', selectedOptions)
    form.setFieldsValue({ type: v });
    nameslist.current = selectedOptions
  };

  const submitPicture = (values: any) => {
    console.log(values, defaultRoom)
    if (!values.length) {
      return
    }
   
  
   
  }

  const onFinish = async (values: any) => {
    console.log(values);

    const formData = new FormData();
    const uploadedList: any[] = [];
    const unloadedList: any[] = [];
    if (values.image && values.image && values.image.length) {
      values.image.map((file: any) => {
        if (file.file) {
          unloadedList.push(file);
        } else {
          uploadedList.push(file);
        }
      });
    }
    
      
    const params = {
      ...values,
      roomId: defaultRoom?.roomId,
      communityId: defaultRoom?.communityId,
      communityName: defaultRoom?.communityName,
      sourceType: 'wechat',
      reporterType: "personOwner",
      "customerName": ownerInformation?.nickName,
      "customerPhone": ownerInformation?.phonenumber,
      customerId: ownerInformation?.sequenceNbr,
      hasChargeItem: false

    }
    console.log(params);

    if (unloadedList.length) {
      unloadedList.map((file: any) => {
        formData.append('files', file.file);
      });
      await queryCommonUpload(formData).then((res) => {
        if (res?.code === 200) {
          const urls = res?.fileNames;
          const images = (uploadedList || []).map((item: any) => {
            let origin = window.location.origin;
            let pathWithoutOrigin = item.url.replace(origin, '');
            // 获取去掉origin的部分，并确保路径以斜杠开始（如果有需要的话）
            return pathWithoutOrigin;
          });
          params.image = images.length
            ? images?.join(',') + ',' + urls
            : urls;
          console.log(99, images, urls);
        }
      });
    } else {
      const images = (uploadedList || []).map((item: any) => {
        let origin = window.location.origin;
        let pathWithoutOrigin = item.url.replace(origin, '');
        // 获取去掉origin的部分，并确保路径以斜杠开始（如果有需要的话）
        return pathWithoutOrigin;
      });
      params.image = images.length ? images?.join(',') : '';
    }
    params.secondCategoryId = values.type && values.type.length > 1 && values.type[1] || ''
    params.firstCategoryId = values.type && values.type.length > 1 && values.type[0] || ''

    params.secondCategoryName = nameslist.current.length > 1 && nameslist.current[1]?.text || ''
    params.firstCategoryName = nameslist.current.length > 1 && nameslist.current[0]?.text || ''
     console.log(params)
    //  return
    // params.communityName = defaultRoom?.communityName;
    // params.createBy = ownerInformation?.nickName;
    // if (detailData && detailData?.sequenceNbr) {
    //   params.sequenceNbr = detailData?.sequenceNbr
    //   updateTicketRecord(params).then(res => {
    //     if (res && res.code ===200) {
    //       Toast.success('修改更新成功')
    //       history.back()
    //     }
    //   })
    // } else {
      addTicketRecord(params).then(res => {
        if (res && res.code ===200) {
          Toast.success('提交工单成功')
          history.back()
        }
      })
    // }
  };

  return (
    <div className={styles.container}>
      <Form
        className={styles.form}
        form={form}
        ref={formRef}
        onFinish={onFinish}
        footer={
          <div className={styles.buttonBox}>
            <Button round nativeType="submit" type="primary" block>
              提交
            </Button>
          </div>
        }
      >
        <Form.Item
          name={'reporter'}
          label="上报人"
          rules={[{ required: true, message: '请输入' }]}
        >
          <Input placeholder={'请输入'} />
        </Form.Item>
        <Form.Item
          name={'reporterPhone'}
          label="上报电话"
          rules={[{ required: true, message: '请输入' }]}
        >
          <Input placeholder={'请输入'} />
        </Form.Item>
        <Form.Item
          label="报事位置"
          isLink
          name={'position'}
          rules={[{ required: true, message: '请选择' }]}
          trigger={'onConfirm'}
          onClick={(_, action) => {
            action?.current?.open();
          }}
        >
          <Picker popup columns={positionTypeList}>
            {(value) =>
              value
                ? positionTypeList.find((item: any) => item?.value === value)
                    ?.text
                : '' || '请选择'
            }
          </Picker>
        </Form.Item>

        <Form.Item
          name={'positionDesc'}
          label="位置描述"
          rules={[{ required: true, message: '请输入' }]}
        >
          <Input.TextArea
            className={styles.value}
            rows={1}
            placeholder={'请输入'}
          />
        </Form.Item>

        <Form.Item
          label="事件分类"
          isLink
          name={'type'}
          rules={[{ required: true, message: '请选择' }]}
          trigger={'onConfirm'}
          onClick={(_, action) => {
            action?.current?.open();
          }}
        >
          <Cascader popup options={eventList} onFinish={changePicker}>
            {(_, selectedRows, actions) =>
              selectedRows.map((el) => el.text).join('/')
            }
          </Cascader>
        </Form.Item>
        <Form.Item
          label="紧急度"
          isLink
          name={'urgent'}
          rules={[{ required: true, message: '请选择' }]}
          trigger={'onConfirm'}
          onClick={(_, action) => {
            action?.current?.open();
          }}
        >
          <Picker popup columns={ugentTypeList}>
            {(value) => (value ? ugentTypeList.find((item: any) => item?.value === value)
                    ?.text : '' || '请选择')}
          </Picker>
        </Form.Item>

        <Form.Item
          name={'ticketContent'}
          label="事件描述"
          rules={[{ required: true, message: '请输入' }]}
        >
          <Input.TextArea
            className={styles.value}
            rows={1}
            placeholder={'请输入'}
          />
        </Form.Item>

        <Form.Item
          name={'image'}
          label="上传图片"
          rules={[{ required: false, message: '请上传图片' }]}
        >
          <Uploader
            onChange={v => submitPicture(v)}
            maxSize={5 * 1024 * 1024}
            onOversize={() => Toast.info('文件大小不能超过5M')}
            maxCount={3}
          ></Uploader>
        </Form.Item>
      </Form>
    </div>
  );
};

export default RepairContent;
